import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="research-charity-care-task"
export default class extends Controller {
  static targets = [
    "documentSelect",
    "object",
    "gptResults",
    "form"
  ]

  connect() {
    this.hasBeenEditedState = false
  }

  changeDocument(e) {
    if (e.target.dataset.path) {
      this.objectTarget.data = e.target.dataset.path
      this.gptResultsTarget.classList.add('hidden')
      this.objectTarget.classList.remove('hidden')
    } else if (e.target.dataset.showTarget === "gptResults") {
      this.objectTarget.data = e.target.dataset.path
      this.gptResultsTarget.classList.remove('hidden')
      this.objectTarget.classList.add('hidden')
    }

    const links = e.target.parentElement.querySelectorAll('div');
    links.forEach(link => {
      if (link === e.target) {
        link.classList.add('!text-black')
      } else {
        link.classList.remove('!text-black')
      }
    })
  }

  hasBeenEdited(e) {
    this.hasBeenEditedState = true
  }

  formSubmitted(e) {
    if (!this.hasBeenEditedState) {
      if (!confirm("You have not edited anything. Are you sure you want to submit?")) {
        e.preventDefault()
      }
    }
  }
}
